export enum SubscriptionState {
  DRAFT = 'draft',
  PENDING = 'pending',
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  PENDING_TERMINATION = 'pending_termination',
  CANCELLED = 'cancelled',
  UNKNOWN = 'unknown',
}
